import { ROUTE_ACCOUNT_EDIT_PERSONAL_INFO } from '@/constants/routes';
import { Box, Flex, Text } from '@cmpsr/components';
import AccountItem from '../../../common/account-item';
import EditLink from '../edit-link/edit-link';

export type PersonalInfoProps = {
  name: string;
  email: string;
};

export default function PersonalInfo({ name, email }: PersonalInfoProps) {
  return (
    <Flex
      flexDirection="column"
      p={{ base: 'spacer-4', md: 'spacer-6' }}
      flexGrow={1}
      width={{ base: '100%', lg: 'auto' }}
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
      backgroundColor="background-light"
      gap="spacer-4"
    >
      <Box display="flex" justifyContent="space-between">
        <Text variant="text-header-M">Personal Info</Text>
        <EditLink route={ROUTE_ACCOUNT_EDIT_PERSONAL_INFO} />
      </Box>
      <AccountItem label="name" value={name || '-'} />
      <AccountItem label="email" value={email} />
    </Flex>
  );
}
